import homeApi from "@/api/homeApi";
import { keyDidAtom, refreshLocAtom, toggleCityAtom } from "../app";
import { commonStateAtom } from "../common";
import { jotaiStore } from "@/atoms/store.ts";
import {
  clearKeyAidBidCidDidWhenRefreshingLoc,
  persistKeyAidFromHomeOrLocationResponseInfoKey,
} from "./weatherQueryShared";

export const loadLocation = async (params: any = {}) => {
  const { get, set } = jotaiStore;
  const refreshloc = get(refreshLocAtom);
  const toggleCity = get(toggleCityAtom);
  return new Promise(async (resolve, reject) => {
    try {
      const newParams = {
        ...params,
        ...get(commonStateAtom)?.params,
      };
      clearKeyAidBidCidDidWhenRefreshingLoc(newParams, !!refreshloc || !!toggleCity);
      const resData = await homeApi.queryLocation(newParams);
      const infoData = resData?.data?.info;
      persistKeyAidFromHomeOrLocationResponseInfoKey(infoData?.key);
      if (infoData?.keyDid) {
        set(keyDidAtom, infoData.keyDid);
      }
      resolve(resData.data);
    } catch (err: any) {
      reject(err);
    } finally {
    }
  });
};
